import { Icon, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { motion } from "framer-motion";
import { t } from "i18next";
import { TbTrash, TbX } from "react-icons/tb";

import { DarwinAvatar } from "@/components/ai-chat/darwin-avatar";
import { ChatHeaderProps } from "@/components/ai-chat/types/chat-header.types";
import {
    DARWIN_AVATAR_LAYOUT_ID,
    DARWIN_AVATAR_LAYOUT_TRANSITION,
    DARWIN_AVATAR_SIZE,
} from "@/constants/ai-chat";
import { cn } from "@/lib/utils";
import { buttonHover, fadeIn } from "@/utils/animations";

export function ChatHeader({
    onClose,
    onClearHistory,
    className,
    avatarState = "idle",
    showAvatar = true,
}: ChatHeaderProps) {
    return (
        <motion.div
            className={cn(
                "flex items-center justify-between p-4",
                "border-b border-border/80 dark:border-white/15",
                className
            )}
            {...fadeIn}
            transition={{ duration: 0.2 }}
        >
            <div className="flex items-center gap-3">
                {showAvatar ? (
                    <motion.div
                        layoutId={DARWIN_AVATAR_LAYOUT_ID}
                        transition={DARWIN_AVATAR_LAYOUT_TRANSITION}
                        className="flex h-11 w-11 shrink-0 items-center justify-center overflow-visible rounded-2xl bg-gradient-to-br from-violet-500/20 via-fuchsia-500/15 to-cyan-500/20 ring-1 ring-white/30 dark:ring-white/10"
                    >
                        <DarwinAvatar size={DARWIN_AVATAR_SIZE.HEADER} state={avatarState} />
                    </motion.div>
                ) : null}
                <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white text-sm">{t("darwin")}</h3>
                    {showAvatar ? (
                        <p className="text-xs text-gray-500 dark:text-white/60">{t("how_can_i_help_you")}</p>
                    ) : null}
                </div>
            </div>

            <div className="flex items-center gap-1">
                {showAvatar ? (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <motion.button
                                {...buttonHover}
                                onClick={onClearHistory}
                                className="p-1.5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg transition-colors group"
                            >
                                <Icon
                                    icon={TbTrash}
                                    className="text-gray-600 dark:text-white/70 group-hover:text-red-500 transition-colors"
                                />
                            </motion.button>
                        </TooltipTrigger>
                        <TooltipContent>{t("clear_chat_history")}</TooltipContent>
                    </Tooltip>
                ) : null}

                <Tooltip>
                    <TooltipTrigger asChild>
                        <motion.button
                            {...buttonHover}
                            onClick={onClose}
                            className="p-1.5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg transition-colors"
                        >
                            <Icon icon={TbX} className="text-gray-600 dark:text-white/70" />
                        </motion.button>
                    </TooltipTrigger>
                    <TooltipContent>{t("close")}</TooltipContent>
                </Tooltip>
            </div>
        </motion.div>
    );
}
